import { BaseResponse } from '../../response/internal/baseresponse';

export class Alert extends BaseResponse {
  constructor(type: AlertType, isError: boolean) {
    super();
    this.type = type;
    this.IsError = isError;
    if (isError === false) {
      this.ErrorCode = '';
    }
  }
  data?: boolean;
  type?: AlertType;
}

export enum AlertType {
  Alert, Confirm, InputConfirmForm
}


// WEBPACK FOOTER //
// ./src/app/model/shared/alert.ts